var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "card") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 24 24 24 24 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,8 L21,8 L21,6 L3,6 L3,8 Z M3,18 L3,12 L20.998,12 L20.997,18 L3,18 Z M21,4 L3,4 C1.897,4 1,4.897 1,6 L1,18 C1,19.103 1.897,20 3,20 L21,20 C22.103,20 23,19.103 23,18 L23,6 C23,4.897 22.103,4 21,4 Z",
    id: "Fill-2",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,14 L5,14 C4.724,14 4.5,13.776 4.5,13.5 C4.5,13.224 4.724,13 5,13 L14,13 C14.276,13 14.5,13.224 14.5,13.5 C14.5,13.776 14.276,14 14,14",
    id: "Fill-4",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,16 L5,16 C4.724,16 4.5,15.776 4.5,15.5 C4.5,15.224 4.724,15 5,15 L10,15 C10.276,15 10.5,15.224 10.5,15.5 C10.5,15.776 10.276,16 10,16",
    id: "Fill-5",
    fill: "#444444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.e19af98bdad22bd48aafda620959ed92.svg";
export { ForwardRef as ReactComponent };